import {createSlice} from "@reduxjs/toolkit";

const initialGuidePatentsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  guidePatentForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const guidePatentsSlice = createSlice({
  name: "guidePatents",
  initialState: initialGuidePatentsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getGuidePatentById
    guidePatentFetched: (state, action) => {
      state.actionsLoading = false;
      state.guidePatentForEdit = action.payload.guidePatentForEdit;
      state.error = null;
    },
    // findGuidePatents
    guidePatentsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createGuidePatent
    guidePatentCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.guidePatent);
    },
    // updateGuidePatent
    guidePatentUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.guiPatentId === action.payload.guidePatent.guiPatentId) {
          return action.payload.guidePatent;
        }
        return entity;
      });
    },
    // deleteGuidePatent
    guidePatentDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.guiPatentId !== action.payload.guiPatentId);
    },
    // deleteGuidePatents
    guidePatentsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.guiPatentId)
      );
    },
  }
});
